import * as React from "react";
const SvgFiRrRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14 22.03c-.39 0-.78-.08-1.16-.23a2.96 2.96 0 0 1-1.85-2.75v-2.06H3.97c-2.19 0-3.97-1.8-3.97-4.01V11c0-2.21 1.78-4.01 3.97-4.01H11V4.93c0-1.23.71-2.28 1.85-2.75a2.92 2.92 0 0 1 3.24.65l6.72 6.33.02.02a3.977 3.977 0 0 1 0 5.62l-6.77 6.37c-.56.56-1.3.86-2.06.86M3.97 8.99C2.88 8.99 2 9.89 2 11v1.98c0 1.11.89 2.01 1.97 2.01H12c.55 0 1 .45 1 1v3.06c0 .6.47.84.61.9s.64.22 1.07-.21l6.77-6.37c.74-.74.75-1.99-.01-2.76l-6.73-6.33a1 1 0 0 0-1.09-.24c-.14.06-.61.3-.61.9v3.05c0 .55-.45 1-1 1z"
    />
  </svg>
);
export default SvgFiRrRight;
